import { useMemo } from "react";

import { useProjects } from "@/features/projects/api";
import { ServiceTile } from "@/features/projects/components/ServiceIcon";
import type { ComboboxOption } from "@/shared/ui/Combobox";

/**
 * The projects a task can be created in or moved into: open ones (active or on hold) where the
 * person may create tasks, as picker options keyed by the project's key.
 */
export function useTaskProjectOptions() {
  const projects = useProjects("open");
  const options = useMemo<ComboboxOption[]>(
    () =>
      (projects.data ?? [])
        .filter((project) => project.abilities.create_tasks)
        .map((project) => ({
          value: project.key,
          label: project.name,
          description: project.key,
          keywords: [project.key],
          leading: <ServiceTile service={project.service} size="sm" />,
        })),
    [projects.data],
  );
  return { options, isPending: projects.isPending };
}
